/******************************************************************************
 * Composant d'affichage des filtres actifs
 *****************************************************************************/

import { IconButton, Tooltip } from "@material-tailwind/react";
import { t } from "i18next";
import { TableCellsIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import ExportModal from "./ExportModal";
import { SearchQuery, SortDirection } from "../../services/api/search";

interface ExportButtonProps<T> {
  filters?: Record<string, any>;
  descriptor: any;
  fileName: string;
  entityName: string;
  /** Omit in `rows` mode: a view with its data in hand has no filters to translate. */
  getQueryFromFilter?: (filters: any) => SearchQuery[]
  /** The table's active sort, so the workbook matches the order on screen. */
  order?: { by: string; direction: SortDirection };
  /** Scoping the parent view applies on top of the filter drawer, e.g. a customer's interventions. */
  extraQueries?: SearchQuery[];
  /** Export these rows directly, for views that hold their data in memory and never search. */
  rows?: T[];
}

/**
 * ExportButton - opens the export confirmation dialog for a list view.
 *
 * Everything that shapes the displayed data has to be handed over, not just the filters — see
 * ExportModal for why `order`, `extraQueries` and `rows` exist.
 *
 * @param filters - active filter values
 * @param descriptor - column mapping for the workbook
 * @param fileName - downloaded file name
 * @param getQueryFromFilter - maps filters to search queries
 * @param entityName - search entity, e.g. "customers"
 * @param order - the table's active sort
 * @param extraQueries - scoping queries applied on top of the filters
 * @param rows - export these rows directly instead of searching
 */
function ExportButton<T>({
  filters,
  descriptor,
  fileName,
  getQueryFromFilter,
  entityName,
  order,
  extraQueries,
  rows
}: ExportButtonProps<T>) {
  const [downLoad, setDownLoad] = useState<boolean>(false);   
 
  return (
    <div>

    <Tooltip content={t("common:export.title")} placement="top">
      {/* Icon-only, so the tooltip text has to be the accessible name too: a tooltip is not one. */}
      <IconButton
        color="white"
        size="sm"
        aria-label={t("common:export.title")}
        onClick={() => setDownLoad(true)}
      >
        <TableCellsIcon className="w-[24px]" />
      </IconButton>
    </Tooltip>
      {downLoad &&
        <ExportModal<T> open={downLoad} filters={filters} entityName={entityName}
          fileName={fileName} descriptor={descriptor}
          onClose={() => setDownLoad(false)} getQueryFromFilter={getQueryFromFilter}
          order={order} extraQueries={extraQueries} rows={rows} />
      }
    </div>

  );
}

export default ExportButton;
